import { queryGqlApi } from '../../graphql/queryGqlApi';
import { CrudServices } from '../../platform/services/types/ServiceDependencies';

const sendAcknowledgementRemindersMutation = /* GraphQL */ `
  mutation SendAcknowledgementReminders($input: SendAcknowledgementRemindersInput!) {
    sendAcknowledgementReminders(input: $input) {
      success
      created
    }
  }
`;

export const sendAcknowledgementReminders = (
    services: CrudServices,
    itemId: string,
    userIds: string[]
) => {
    return queryGqlApi(
        sendAcknowledgementRemindersMutation,
        {
            input: {
                itemId,
                userIds,
            },
        },
        services.dataClientService,
        services.authService,
        'pgServer'
    );
};
